import React, { useEffect, useState } from "react";
import styled from "styled-components";
import logo from "../assets/logo.png";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <Nav $scrolled={scrolled}>
      <Logo>
        <img src={logo} alt="" />
      </Logo>
      <Links>
        <a href="#features">Features</a>
        <a href="#why">Why Siara</a>
        <CtaLink href="/checkout">Shop Now</CtaLink>
      </Links>
    </Nav>
  );
};

const Nav = styled.nav`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 1.4rem 4rem;
  transition:
    background 0.4s ease,
    backdrop-filter 0.4s ease,
    padding 0.4s ease;
  background: ${({ $scrolled }) =>
    $scrolled ? "rgba(253, 248, 245, 0.88)" : "transparent"};
  backdrop-filter: ${({ $scrolled }) => ($scrolled ? "blur(16px)" : "none")};
  padding-top: ${({ $scrolled }) => ($scrolled ? "1rem" : "1.4rem")};
  padding-bottom: ${({ $scrolled }) => ($scrolled ? "1rem" : "1.4rem")};

  @media (max-width: 768px) {
    padding: 1.2rem 1.5rem;
  }
`;

const Logo = styled.span`
  font-family: var(--serif);
  font-size: 1.5rem;
  font-weight: 500;
  letter-spacing: 0.3em;
  color: var(--dark);
  img {
    width: 100px;
  }
`;

const Links = styled.div`
  display: flex;
  align-items: center;
  gap: 2.5rem;

  a {
    font-family: var(--sans);
    font-size: 0.78rem;
    font-weight: 400;
    letter-spacing: 0.15em;
    text-transform: uppercase;
    color: var(--mid);
    transition: color 0.25s ease;

    &:hover {
      color: var(--dark);
    }
  }

  @media (max-width: 768px) {
    gap: 1.2rem;

    a:not(:last-child) {
      display: none;
    }
  }
`;

const CtaLink = styled.a`
  font-family: var(--sans) !important;
  font-size: 0.75rem !important;
  font-weight: 500 !important;
  letter-spacing: 0.18em !important;
  text-transform: uppercase !important;
  color: var(--cream) !important;
  background: var(--dark);
  padding: 0.65rem 1.6rem;
  border-radius: 100px;
  transition:
    background 0.3s ease,
    transform 0.2s ease !important;

  &:hover {
    background: var(--gold) !important;
    transform: translateY(-1px);
  }
`;

export default Navbar;
